import React           from "react";
import ReactDOM         from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App              from "./App.js";
import "./styles/global.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
